<template>  
  <div id="centre-div-parent" :class="{'rel-grid-container' : browser_good}" style="max-width:100%;">
    <div id="top-div" style="min-height:50px;"></div>
    <div v-if="!browser_good">
      <div id="logo-box">
      </div>
      <span id="loginText">{{$t('login.ie_message_1')}}</span>
      <span id="loginText">{{$t('login.ie_message_2')}}</span>
    </div>
    <div v-if="browser_good">
      <div id="logo-box">
      </div>
      <!--<div id="language-flags" class="fit-content">
        <b-button v-for="language in languageOptions" :key="language.id"  :class="{'submit-button4' : true, 'active-flag': $i18n.locale == language.abbrev}" class="language-flag"  v-on:click="loadLanguageAsync(language.abbrev)" variant="clear-blue" ><img :src="getImgUrl('flags/'+language.flag+'.png')" v-bind:alt="language.flag+' flag'"></b-button>
      </div>
      <br />-->
      <div id="cc-box" v-if="isCorporateConnections">

      </div>
      <div class="login-form" style="margin-bottom: 30px;height: 300px;position:relative; overflow:hidden;">
        <span class="centre-text log-title" style=" height: 50px;line-height: 40px;border-bottom: 1px solid #aaa;">{{$t('login.permission_text')}}</span><br />
        <span class="centre-text" v-if="loginStep<2" style="color: #ccc;">{{$t('login.login_sub_text')}}</span><br />
        <transition :name="slide_transition">
          <div v-if="loginStep==0" key="login1" style="position: absolute;width: 100%;">
            <form  v-on:submit.prevent="submitEmail" style="display:grid;grid-template-columns: auto max-content;margin:auto;" class="fit-width">
              <b-form-input :placeholder="$t('login.username_text')" class="login-field" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" v-model="username"  required></b-form-input>
              <b-form-input style="grid-column: 1/2;opacity:0;" :placeholder="$t('login.password_text')" class="login-field"  type="password" v-model="password"></b-form-input>
              <b-button style="margin: auto 10px;padding: 0px;grid-row:1/2;grid-column:2/3;" class="submit-button4" type="submit" variant="clear-blue"><div style="width: 35px !important;height: 35px !important;" class="next-button"></div></b-button>
            </form>
          </div>
          <div v-if="loginStep==1" key="login2" style="position: absolute;width: 100%;">
            <form v-on:submit.prevent="login" style="display:grid;grid-template-columns: auto max-content;margin:auto;" class="fit-width">
              <b-form-input :placeholder="$t('login.username_text')" class="login-field" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" v-model="username"  required></b-form-input>
              <b-form-input id="password-field" style="grid-column: 1/2;" :placeholder="$t('login.password_text')" class="login-field"  type="password" v-model="password"  required></b-form-input>
              <b-button style="margin: auto 10px;padding: 0px;" class="submit-button4" type="submit" variant="clear-blue"><div style="width: 35px !important;height: 35px !important;" class="next-button"></div></b-button>
              
            </form>
            <b-btn v-on:click="reset_name=username;showResetSuccess=false;showPassReset = true;" style="text-align: center;width: 100%;    margin: 20px auto auto auto;" variant="link">{{$t('login.forgot_password')}}</b-btn>
          </div>
        <div v-if="loginStep==2 || loginStep == 3" key="login3" style="display:grid; grid-template-rows: auto max-content auto;position: absolute;width: 100%;">
          <div></div>
          <div style="text-align:center;">
            <p v-html="$t('login.email_sent')"></p><br v-if="loginStep == 3"/>
            <p v-if="loginStep == 3" v-html="$t('login.further_access')"></p>
          </div>
          <div></div>
        </div>
        </transition>
      </div>
      <b-alert class="fit-width" variant="danger" dismissible :show="showAlert" @dismissed="showAlert=false" style="text-align:center;grid-column:1/3;margin:auto;"> {{alertText}} </b-alert>
      <!--<b-alert variant="success" dismissible :show="showResetSuccess" @dismissed="showResetSuccess=false" style="text-align:center;"><span>{{$t('login.reset_success1')}}</span>
            </b-alert>-->
      <!--<div class="login-form">
        <span class="centre-text log-title">{{$t('login.request_text1')}}</span>
        <br />
        <span class="centre-text " style="font-size:14px;color:#aaa;">{{$t('login.request_text2')}}</span>
        <b-form-input id="email-reset" type="text" name="password" v-model="requestEmail" :placeholder="$t('login.member_email')" required></b-form-input>
        <div v-if="showRequestAlert">
          <b-alert variant="danger"
                   dismissible
                   :show="showRequestAlert"
                   @dismissed="showRequestAlert=false" style="text-align:center;">
            {{alertRequestText}}
          </b-alert>
        </div>
        <div v-if="showRequestSuccess">
          <b-alert variant="success"
                   dismissible
                   :show="showRequestSuccess"
                   @dismissed="showRequestSuccess=false" style="text-align:left;">
            <div>{{$t('login.request_success1')}}</div>
            <div>{{$t('login.request_success2')}}</div>
          </b-alert>
        </div>
        <b-button style="margin:20px auto;" class="submit-button4" v-on:click="checkPassThenSend" variant="clear-blue"><div class="email-button"></div><span>{{$t('login.request_link')}}</span></b-button>
      </div>-->
      <!--<div id="login-footer">
        <span>{{$t('login.bottom2_text')}} <a href="mailto:support@meetinghub.biz">support@meetinghub.biz</a></span>
        <span>{{$t('login.bottom1_text')}}</span>
      </div>-->
      <div class="footer white-text center">
          Meeting HUB for {{isCorporateConnections? 'Corporate Connections' : 'BNI'}} was designed and developed by Meeting HUB Inc.<br>
          © Meeting HUB Inc. 2021, All Rights Reserved.<br>
          Use of Meeting HUB is subject to our <a v-on:click="goTerms()" class="clickable" target="_blank"><u>Terms and Conditions</u></a> and <a class="clickable" v-on:click="goPrivacy()" target="_blank"><u>Privacy Policy</u></a>.
        </div>
    </div>
    <b-modal centered v-model="showLeadership" >
      <div slot="modal-header">
      </div>
          <div style="text-align:center;">
            <div><b>{{$t('login.leadership_text2')}}</b><br/>{{$t('login.leadership_text3')}}</div>
            <br/>
            <div>{{$t('login.leadership_text4')}}</div><br/>
            <div v-for="leader in leadership" :key="leader.id">
              <b-button  size="sm" @click.stop="loginAsLeader(leader)" variant="light-blue-outline" style="margin: 5px;border-radius: 20px;width: 320px; text-align:center;">
              {{leader.name}} - <i>{{leader.role_name}}</i>
            </b-button>
            </div>
            <br/>
            <div>{{$t('login.leadership_text5')}}</div>
            <div>{{$t('login.leadership_text6')}}</div>
            <br/>
            <b-button  v-on:click="goToDash" variant="link" style='font-weight: bold;'>
              {{$t('login.leadership_text7')}}
            </b-button>
        </div>
        <div slot="modal-footer">
        </div>
      </b-modal>
      <b-modal id="modal-center" class="login-modal" v-model="showPassReset" centered :title="$t('login.forgot_password')">
          <div>{{$t('login.forgot_text_1')}}</div>
          <div>{{$t('login.forgot_text_2')}}</div>
          <div class="fit-width" style="display: grid; margin: 10px auto;">
            <span class="form-box-name">{{$t('login.account_name')}}</span><b-form-input v-model="reset_name" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" class="form-box-input"></b-form-input>
          </div>
          <div v-if="showResetAlert" style="text-align: center;">
            <b-alert variant="danger" dismissible :show="showResetAlert" @dismissed="showResetAlert=false" style="text-align:center;">
                     {{reset_alert}}
            </b-alert>
          </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showPassReset=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="resetPass" variant="clear-blue"><div class="email-button"></div><span>{{$t('global.button_send')}}</span></b-button>
          </div>
        </b-modal>
      <b-modal centered v-model="showSelectedLeader" >
      <div slot="modal-header">
      </div>
          <div v-if="currentLeader && !currentLeader.has_pass" style="text-align:center;">
              <div v-html="$t('login.leadership_email_sent')"></div>
              <br/>
              <b-button  v-on:click="showSelectedLeader=false;" variant="link">
              {{$t('global.button_ok')}}
            </b-button>
          </div>
          <div v-if="currentLeader && currentLeader.has_pass" style="text-align:center;">
            <div>{{$t('login.leadership_exists')}}</div>
            <br/>
            <b-button  v-on:click="username=currentLeader.email; password=''; showSelectedLeader=false;" variant="link">
              {{$t('login.leadership_login')}}
            </b-button>
            <br/>
            <div>{{$t('login.leadership_reset')}}</div>
          </div>
        <div slot="modal-footer">
        </div>
      </b-modal>
      <b-modal centered v-model="showHasPass" >
      <div slot="modal-header">
      </div>
          <div>
            {{$t('login.has_pass')}}
          </div>
        <div slot="modal-footer" class="submit-box-2">
              <b-button class="submit-button4" v-on:click="username=requestEmail;showHasPass=false;" variant="clear-blue"><div class="login-button"></div><span>{{$t('global.button_login')}}</span></b-button>
              <b-button class="submit-button4" v-on:click="sendEmail" variant="clear-blue"><div class="email-button"></div><span>{{$t('login.send_email')}}</span></b-button>
            </div>
      </b-modal>
  </div>
</template>
<style scoped lang="scss">
.log-title{
      background-color: $VUE_APP_COLOUR_LOGO_BACK;
    padding: 5px;
    font-size: 18px;
     color: $VUE_APP_MENU_TEXT;
}
#cc-box{
  margin: auto;margin-bottom:25px; 
    background-image: url("../assets/CClogo-horizontal-white.png");
    background-repeat: no-repeat;
    background-size: auto 130px;
    background-position: center;
    width:100%;
    background-color: #424143;
    height: 150px;
}
#logo-box{
     margin: auto;margin-bottom:25px; max-width: 600px;
    background-image: url("../assets/logo-MeetingHubwSlogan2020.png");
    background-repeat: no-repeat;
    background-size: auto 150px;
    background-position: center;
    width:600px;
    background-color: #FFFFFF;
    height: 150px;
}
#language-flags{
  display:grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr;margin:auto;
}
.language-flag{
  margin: auto 10px;padding:0px;
}
.login-field{
  max-width:400px; margin:10px auto;background-color:#e0f5fd;
}
#email-reset{
  max-width:400px; margin:10px auto;background-color:#e0f5fd;
}
#login-footer{
  text-align:center;display:grid;margin-top:30px;color:#777;font-size:12px;
}
  .login-modal .modal-dialog {
    max-width: 700px;
    width: 700px;
  }
  .centre-text {
    text-align: center;
    display: block;
    font-weight: normal;
  }
  #centre-div-parent {
    position: absolute;
    top: 0px;
    bottom: 0px;
    right: 0px;
    left: 0px;
    display: grid;
    grid-template-rows: auto auto auto;
    text-align: center;
  }

  #terms-modal .modal-dialog {
    width: 80%;
    max-width:80%;
  }
  .submit-button-login {
    width: 162px;
    height: 46px;
    margin: auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 0px 15px;
  }
  
  #choiceDiv {
    text-align: center;
  }
  .login-form {
    
    border: solid 1px #aaa;
    max-width: 600px;
    margin: auto;
    text-align: right;
  }
.login-form h1 {
	text-align: center;
	color: #4d4d4d;
	font-size: 24px;
	padding: 20px 0 20px 0;
}
.login-form input[type="password"],
.login-form input[type="text"] {
	width: 100%;
	padding: 15px;
	border: 1px solid #dddddd;
	margin-bottom: 15px;
	box-sizing:border-box;
}
.login-form input[type="submit"] {
	width: 100%;
	padding: 15px;
	background-color: #535b63;
	border: 0;
	box-sizing: border-box;
	cursor: pointer;
	font-weight: bold;
	color: #ffffff;
}
  #loginText, #permission {
    width: 100%;
    display: block;
  }
#forgotPass{
	font-size: 12px;
	color: #B2CEF0;
	display: block;
	text-align:left;
}
.righttolefttrans-enter-active, .righttolefttrans-leave-active {
    transition: all 0.5s ease-in;
  }
  .righttolefttrans-enter {
    transform: translateX(100%);
  }
  .righttolefttrans-leave-to {
    transform: translateX(-100%);
  }
  .footer{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 75px;
        background-color: #000;
        padding: 8px 0 0 0;
        font-size: 13px;
        text-align: center;
        color: #fff !important;
    }
</style>
<script>  
  import router from "../router"    
      
  export default {    
    name: "Login",
     watch: {
      '$i18n.locale': {
        handler: function () {
          document.title = this.$t('global.document_title');
        },
        deep: true
      },
    },
    data() {
      return {
        slide_transition : "righttolefttrans",
        showHasPass: false,
        showSelectedLeader: false,
        showLeadership: false,
        showResetSuccess: false,
        languageOptions: [],
        showRequestSuccess: false,
        showRequestAlert: false,
        alertRequestText: "",
        cantAccept: true,
        showTerms: false,
        showPassReset: false,
        reset_name: "",
        showAlert: false,
        alertText: this.$t('login.alert_text'),
        showResetAlert: false,
        alertResetText: "",
        password: "",
        username: "",
        pages: [{ url: "/admin/dashboard", name: this.$t('login.login_option1') }, { url: "/controller/view", name: this.$t('login.login_option2')}],
        redirect: "/admin/dashboard",
        browser_good: true,
        requestEmail: "",
        reset_alert: "",
        leadership: [],
        currentLeader: null,
        loginStep: 0
      }
    },
    methods: {
      submitEmail(){
        this.showAlert = false;
        this.$http.post("/api/member/logininfo", { email: this.username }).then((response) => {
          if (response.data.success === true) {
            if(response.data.has_pass==1){
              this.loginStep = 1;
              if(this.password.length>0){
                this.login();
              }
              setTimeout(() => {
                document.getElementById("password-field").focus();
              }, 500);
              
            }else if(response.data.some_access){
              this.loginStep = 2;
              this.sendEmail(this.username);
            }else{
              this.loginStep = 3;
              this.sendEmail(this.username);
            }
          }else{
            
            this.alertText = this.$t('login.alert_no_account');
            this.showAlert = true;
          }
        }).catch((e) => { 
          console.log(e);
          this.alertText = this.$t('login.alert_no_account');
            this.showAlert = true;});
      },
      loginAsLeader(leader){
        this.currentLeader = leader;
        if(this.currentLeader.has_pass){
          this.showSelectedLeader = true;
          this.showLeadership = false;
        }else{
          this.$http.post("/api/password/reset", {name: this.currentLeader.email}).then((response) => {
          if (response.data.sent === true) {
           this.showSelectedLeader = true;
           this.showLeadership = false;
          }
        }).catch(() => {
        });
        }
        
      },
       getLanguages(){
        this.$http.post("/api/organization/languages/all", {}).then((response) => {
          if (response.data.success === true) {
            this.languageOptions = response.data.languages;
          }
        }).catch((errors) => {
          console.log(errors)
        });
      },
      goToSignup(){
        router.push("/setup");
      },
      getLeadership(){
        this.$http.post("/api/organization/leadership", {}).then((response) => {
          if (response.data.success === true) {
            this.leadership = response.data.leadership;
            if(this.leadership.length<3){
              this.goToDash();
            }else{
              this.showLeadership = true;
            }
          }
        }).catch((errors) => {
          console.log(errors)
        });
      },
      acceptedTerms() {
        this.showAlert = false;
        let data = {
          username: this.username,
          password: this.password,
          admin: this.redirect === "/admin/dashboard"
        }
        this.$http.post("/api/terms", data).then((response) => {
          if (response.data.success === true) {
            if (response.data.terms === true) {
              this.auth();
            } else {
              this.showTerms = true;
            }
          } else {
            this.alertText = this.$t('login.alert_text');
            this.showAlert = true;
          }
        }).catch(() => {
          this.alertText = this.$t('login.alert_text2');
          this.showAlert = true;
        });
      },
      changedRedirect() {
      },
      login() {
        if(this.password==""){
          return;
        }
        this.showAlert = false;
        let data = {    
          username: this.username,    
          password: this.password,
          admin: this.redirect === "/admin/dashboard"
        }    
        this.$http.post("/api/login", data).then((response) => {
          if (response.data.success === true) {
            if (response.data.terms === true) {
              this.auth();
            } else {
              this.showTerms = true;
            }
          } else if(response.data.error){
            if(response.data.error.code == 1){
              this.alertText = this.$t('login.alert_text');this.showAlert = true;}
            else  if(response.data.error.code == 2){
              this.alertText = this.$t('login.alert_disabled');this.showAlert = true;}
            else if(response.data.error.code == 101){
              this.alertText = this.$t('login.alert_dev');}
            this.showAlert = true;
          }
        }).catch(() => {
          this.alertText = this.$t('login.alert_text2');
          this.showAlert = true;
        });
      },
      goToDash(){
        if(this.isMobile()){
              router.push("/mobile");
            }else {
              router.push("/admin/dashboard/");
            }
      },
      auth(){
        var self = this;
        this.loginAuthenticate(function(){
            self.permissions.previousSpeakers = false;
            self.permissions.previousDates = false;
            self.permissions.showDisabledSlides = true;
            self.permissions.filterRoleId = 0;
            self.permissions.sectionFilterId = 0;
            self.permissions.shownAnnouncements = false;
            self.permissions.populateVariables = !self.permissions.organization.is_parent;
            if(self.permissions.admin==1 && !self.permissions.organization.is_parent){
              self.getLeadership();
              return;
            }
            if(self.permissions.admin ==0 && self.permissions.access == 0){
              if(self.permissions.organization.parent_name == "" || self.permissions.organization.parent_name == null){
                router.push("/contactdash");
              }else{
                self.$http.post("/api/member/getmanagepermissions", {}).then((response) => {
                if (response.data.success && response.data.some_access) {
                  router.push("/userdash");
                }else{
                  router.push("/memberinfo/"+self.permissions.user.uid);
                }
              }).catch(() => {
                router.push("/memberinfo/"+self.permissions.user.uid);
              });
              }
              
            }else if(self.permissions.organization.id == 1){
              router.push("/admin/regions");
           // }else if(self.permissions.organization.needs_payment || self.permissions.organization.payment_due){
            //  router.push("/payment");
            //}else if(self.permissions.organization.onboard>=0 && !self.permissions.organization.is_parent){
            //  router.push("/onboard");
            }else if (self.permissions.organization.is_parent && self.redirect == "/admin/dashboard") {
              router.push("/admin/regiondash");
            } else if(self.isMobile()){
              router.push("/mobile");
            }else {
              router.push(self.redirect);
            }
        })
      },
      resetPass(e) {
        this.showResetAlert = false;
         this.showResetSuccess = false;
        e.preventDefault();
        this.$http.post("/api/password/reset", {name: this.reset_name}).then((response) => {
          if (response.data.sent === true) {
            this.showResetAlert = false;
            this.showPassReset = false;
            this.showResetSuccess = true;
          } else {
            this.reset_alert = response.data.errorcode>0? this.$t('login.reset_alert'+response.data.errorcode): this.$t('login.reset_error');
            this.showResetAlert = true;
          }
        }).catch(() => {
          this.reset_alert = this.$t('login.reset_error');
          this.showResetAlert = true;
        });
      },
      checkPassThenSend(){
        this.$http.post("/api/member/haspass", { email: this.requestEmail }).then((response) => {
          if (response.data.success === true) {
            if(response.data.has_pass==1){
              this.showHasPass = true;
            }else{
              this.sendEmail();
            }
          } 
        }).catch(() => { });
      },
      sendEmail(username) {
        //this.showHasPass=false;
        //this.showRequestAlert = false;
        //this.showRequestSuccess = false;
        this.$http.post("/api/member/photo/request/email/byemail", { email: username }).then((response) => {
          if (!response.data.success){
            this.showAlert = true;
            this.alertText = response.data.error;
          }
        }).catch(() => { });
      },
      onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
        if (scrollTop + clientHeight >= scrollHeight) {
          this.cantAccept = false;
        }
      },
      isMobile() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4)))check=true})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      },
       goTerms(){
          if(this.isCorporateConnections){
           window.open("/#/terms", "_blank");
          }else{
            window.open("https://canada.meetinghub.biz/terms.html", "_blank");
          }
       },
       goPrivacy(){
         if(this.isCorporateConnections){
           window.open("/#/privacy", "_blank");
         }else{
           window.open("https://canada.meetinghub.biz/privacy.html", "_blank");
         }
           
       }
    },
    mounted() {
      this.setLanguageIfAvailable();
      this.browser_good = this.detectIE() < 0;
      document.title = this.$t('global.document_title');
      this.getLanguages();
    }
  }
</script>
